module.exports = __webpack_public_path__ + "self-icon.0efa4db7ecb9b4488655.svg";


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/assets/images/self-icon.svg
// module id = ../../../../../src/assets/images/self-icon.svg
// module chunks = main